<template>
	<app-page>
		<div class="main-title">
			关于提高科技型中小企业研究开发费用税前加计扣除比例的通知
		</div>
		<div class="flex flex-end clearfix">
			<el-button type="primary" @click="goback()">返回</el-button>
		</div>
		<div class="detail-content">
			<div data-v-bbdef3ee="" class="detail-content">
				<p style="text-align:center;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#999999">财税〔2017〕34号</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"
									>各省、自治区、直辖市、计划单列市财政厅（局）、国家税务局、地方税务局、科技厅（局），新疆生产建设兵团财务局、科技局：</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									为进一步激励中小企业加大研发投入，支持科技创新，现就提高科技型中小企业研究开发费用（以下简称研发费用）税前加计扣除比例有关问题通知如下：</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									一、科技型中小企业开展研发活动中实际发生的研发费用，未形成无形资产计入当期损益的，在按规定据实扣除的基础上，在2017年1月1日至2019年12月31日期间，再按照实际发生额的75%在税前加计扣除；形成无形资产的，在上述期间按照无形资产成本的175%在税前摊销。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									二、科技型中小企业享受研发费用税前加计扣除政策的其他政策口径按照《财政部
									国家税务总局
									科技部关于完善研究开发费用税前加计扣除政策的通知》（财税〔2015〕119号）规定执行。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									三、科技型中小企业条件和管理办法由科技部、财政部和国家税务总局另行发布。科技、财政和税务部门应建立信息共享机制，及时共享科技型中小企业的相关信息，加强协调配合，保障优惠政策落实到位。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">财政部 税务总局 科技部</span></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;"></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">2017年5月2日</span></span
							></span
						></span
					>
				</p>
			</div>
		</div>
	</app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";

export default {
	components: {
		AppPage
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>